import { useStaffText } from '../ui/StaffText'

/**
 * What a section shows in place of its list until the first answer has come,
 * so that a slow line never reads as "nothing is set up yet". See lib/listState.ts.
 */
export function Loading() {
  const { say } = useStaffText()
  return (
    <p className="empty" role="status">
      {say('common.loading')}
    </p>
  )
}
